import React, { useEffect, useState } from 'react';
import CenterSpinner from '../../../../../general/Loadings/CenterSpinner';
import { toast } from 'react-toastify';
import { callTokenApi } from '../../../../../../apiCaller';
import { API_AI_INSIGHTS_INTENT_DATASET_BY_ID, COMPONENT_NAME, TYPE_SHOW_UNSAVE_CHANGE } from '../../../../../../constants';
import NameDescription from './steps/NameDescription';
import BuildEditDataSet from './steps/BuildEditDataSet';
import { setRuleMultiHaveEditing } from '../../../../../../actions/common';
import { useDispatch } from 'react-redux';

export const AIIntentsDetailContext = React.createContext({});

const AIIntentDataSet = ({ attributes }) => {
     const dispatch = useDispatch();
     const { datasetId, viewDatasets, setViewDatasets } = attributes;
     const [isLoading, setIsLoading] = useState(false);
     const [activeStep, setActiveStep] = useState(1);
     const [stepsData, setStepsData] = useState({});
     const [initStepsData, setInitStepsData] = useState({});

     useEffect(() => {
          const loadDataSet = async () => {
               if (!datasetId) return;

               setIsLoading(true);
               try {
                    const templateResponse = await callTokenApi(API_AI_INSIGHTS_INTENT_DATASET_BY_ID.replace(':id', datasetId), 'GET');
                    const dataSetData = templateResponse?.data?.data;

                    if (templateResponse?.status === 200 && dataSetData) {
                         setStepsData({
                              ...dataSetData,
                         });
                    } else {
                         toast.error('Failed to load data set.');
                    }
               } catch (error) {
                    console.error('Fetch data set error:', error);
                    toast.error('An error occurred while loading data set.');
               } finally {
                    setIsLoading(false);
               }
          };

          loadDataSet();
     }, [datasetId]);

     const handleHasChange = (value) => {
          dispatch(setRuleMultiHaveEditing({ show: value, type: TYPE_SHOW_UNSAVE_CHANGE.CREATE_SIMPLE, component: COMPONENT_NAME.AI_INTENT_DATASET_VALUES }) );
     };

     return (
          <React.Suspense fallback={<CenterSpinner />}>
               <div className="rule-detail account-connected-detail ai-insights-templates">
                    {isLoading ? (
                         <CenterSpinner />
                    ) : (
                         <div className="cvr-create-new">
                              <h1 className="pb-3">{datasetId ? `Edit:  Classification Data Set ${stepsData.name}` : 'Create:  Classification Data Set'}</h1>

                              <AIIntentsDetailContext.Provider
                                   value={{
                                        id : datasetId,
                                        activeStep,
                                        setActiveStep,
                                        initStepsData,
                                        setInitStepsData,
                                        stepsData,
                                        setStepsData,
                                        viewDatasets,
                                        setViewDatasets,
                                        handleHasChange
                                   }}
                              >
                                   <NameDescription />
                                   <BuildEditDataSet />
                                 
                              </AIIntentsDetailContext.Provider>
                         </div>
                    )}
               </div>
          </React.Suspense>
     );
};

export default AIIntentDataSet;
